<template>
  <div class="hpnew sub">
    <div class="header" id="top" data-aos="fade" data-aos-duration="1200">
      <div class="hdr_wrap">
        <div class="topbar" data-aos="fade-in" data-aos-duration="2500">
          <amio-menu></amio-menu>
        </div>
        <div class="clear"></div>

        <h2>RCS Business<br/> Messaging</h2>
      </div>
    </div>

    <div class="subpage wrapper d-flex">
      <div class="mx-auto mb-8" style="max-width: 600px;">

        <p class="mb-3">You can try how RCS Business Messaging (RBM) works right now. All you need is a compatible phone (Android 6.0 or newer)
          and a <a href="https://www.gsma.com/futurenetworks/rcs/global-launches/" target="_blank">carrier that supports RCS</a>.
        </p>
        <p class="mb-4">To see the demo, please register your phone number.</p>

        <form @submit.prevent="promiseConnect = connect()">
          <div class="form-group row" >
            <label class="col-4 text-muted col-form-label">
              Phone Number:
            </label>
            <div class="col-8">
              <input class="form-control"
                     :class="{'is-invalid': isPhoneNumberInvalid || serverErrorMessage}"
                     placeholder="+15558576309"
                     v-model="phoneNumber"
                     maxlength="20"/>
              <div v-show="isPhoneNumberInvalid" class="invalid-feedback">
                Please provide a phone number.
              </div>
              <div v-show="serverErrorMessage" class="invalid-feedback">
                Unable to send the request at this time. Please try again later.
              </div>

            </div>
            <p class="small mt-4 pl-3">By submitting the form, you agree
              to be contacted by Amio chatbot via RBM. You can opt-out any time by sending "STOP" message to
              Amio RBM Agent.
            </p>
          </div>

          <div class="row mt-3">
            <div class="col-12 d-flex justify-content-center">
              <button type="submit" v-show="!submitted && !promiseConnect" class="button border-0 px-5">
                I agree
              </button>
              <ring-loader v-show="promiseConnect" color="#6A41FF" :size="35"></ring-loader>
              <button type="button" class="button border-0" disabled v-show="submitted">Message sent&nbsp;&nbsp;✓</button>
            </div>
          </div>
        </form>
      </div>
    </div>

    <amio-footer></amio-footer>
  </div>
</template>

<script>
  import rbmHttpClient from '@/services/rbm.http-client'
  import { RingLoader } from '@saeris/vue-spinners'
  import AmioMenu from '@/components/common/AmioMenu'
  import AmioFooter from '@/components/common/AmioFooter'

  export default {
    components: {
      RingLoader,
      AmioMenu,
      AmioFooter
    },
    metaInfo: {
      title: 'RCS Business Messaging'
    },
    data() {
      return {
        promiseConnect: null,
        isPhoneNumberInvalid: false,
        phoneNumber: '',
        serverErrorMessage: '',
        submitted: false
      }
    },

    methods: {
      connect() {
        this.clearError()
        if (!this.phoneNumber) {
          this.isPhoneNumberInvalid = true
          return
        }

        this.isPhoneNumberInvalid = false
        const data = {
          phone_number: this.phoneNumber
        }

        return rbmHttpClient.post('/contacts', data)
          .then(() => {
            this.promiseConnect = null
            this.submitted = true
          })
          .catch((err) => {
            return this.handleError(err)
          })
      },
      clearError() {
        this.serverErrorMessage = ''
      },

      handleError(error) {
        this.serverErrorMessage = error
        this.promiseConnect = null
      }
    }
  }
</script>
